module.exports = __webpack_public_path__ + "img/65.fbf1469c.png";